// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"CheckboxInput_checkboxWrapper__vrZPw","checkboxInput":"CheckboxInput_checkboxInput__Be06O"};